<template>
    <div class="main">
        <h2>Ways of Seeing 2020</h2>
        <div class="title-box">
            <p class="title">VISION+ India Launch</p>
        </div>
        <ul class="warchFilm">
            <li v-for="(item, index) in list" :key="index">
                <div class="mask"></div>
                <img class="bgImg" :src="item.imgSrc" alt="">
                <div class="content">
                    <p class="title">{{item.title}}</p>
                    <p class="text" @click="openVideoEvent(item.video)"><span>Watch film</span><img :src="logo3" alt=""></p>
                </div>
            </li>
        </ul>
        <div class="title-box">
            <p class="title">Gallery</p>
        </div>
        <div v-if='!isWap' v-swiper:mySwiper="swiperOption" ref="mySwiper">
            <div class="swiper-wrapper">
            <div class="swiper-slide" :key="index" v-for="(banner,index) in banners">
                <div :class='`f${index+1}-box`' class="f-box">
                    <!-- <img :src="banner"> -->
                    <dyna-img :src="banner" />
                </div>
            </div>
            </div>
            <!-- <div class="swiper-pagination"></div> -->
            <div class="swiper-button-prev" slot="button-prev" @click="prev" ></div>
            <div class="swiper-button-next" slot="button-next" @click="next" ></div>
        </div>
        <div v-else class="flimList">
            <div class="scroll">
                <div class="item" :key="index" v-for="(banner,index) in banners">
                    <dyna-img :src="banner" />
                </div>
            </div>
            <p>Slide left to see more<img :src="logo4" alt=""></p>
        </div>
        <div class="logo-box">
            <div class="content">
                <div>Partner</div>
                <dyna-img class="img-left" :src="logo1" />
            </div>
            <div class="content">
                <div>Supported by</div>
                <dyna-img :src="logo2" />
            </div>
        </div>
        <pop-video
        :config="videoConfig"
        :visible="openVideo"
        @closeVideo="closeVideo"
        ></pop-video>
    </div>
</template>

<script>
// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import DynaImg from "@/components/dynaImg";
import { directive } from 'vue-awesome-swiper'
import PopVideo from "@/components/popvideo";
import 'swiper/swiper-bundle.css'
    export default {
        name: 'Ways',
        components: {
            DynaImg,
            PopVideo,
        //     Swiper,
        //     SwiperSlide
        },
        directives: {
            swiper: directive
        },
        data() {
            return {
                banners: [ 
                    'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/gallery-img1-pc.jpg', 
                    'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/gallery-img2-pc.jpg', 
                    'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/gallery-img3-pc.jpg', 
                    'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/gallery-img4-pc.jpg', 
                    'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/gallery-img5-pc.jpg', 
                ],
                swiperOption: {
                    
                    speed: 1300,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false
                    },
                    // 改变swiper样式时，自动初始化swiper
                    observer: true,
                    // 监测swiper父元素，如果有变化则初始化swiper
                    observeParents: true,
                    loop: true,
                    // spaceBetween: 30,
                    centeredSlides: true,
                    slidesPerView: 5,
                    // 设置点击箭头
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    },
                    // ...
                },
                list:[
                    {
                        imgSrc:'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img1-pc.jpg',
                        title: 'What\'s in VISION+',
                        video: {
                            title: "",
                            isIframe: false,
                            videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/af8627fb46719f63e13c4d1ae009076e.mp4",
                            videoPoster:"https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img1-pc.jpg",
                            autoplay: true,
                        }
                    },
                    {
                        imgSrc:'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img2-pc.jpg',
                        title: 'Our Core Philosophy',
                        video: {
                            title: "",
                            isIframe: false,
                            videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/74a4eee32df83cacba0cda752d641807.mp4",
                            videoPoster:
                                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img2-pc.jpg",
                            autoplay: true,
                        },
                    },
                    {
                        imgSrc:'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img3-pc.jpg',
                        title: 'Our Inspiration',
                        video: {
                            title: "",
                            isIframe: false,
                            videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/3d75db306b4ea545ad185dc5faffc789.mp4",
                            videoPoster:
                                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/ways/video-poster-img3-pc.jpg",
                            autoplay: true,
                        },
                    },
                ],
                logo1: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-national-test.svg',
                logo2: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-zeiss-test.svg',
                logo3: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/watchFilm.svg',
                logo4: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/watchFilm2.svg',
                isWap: false,
                openVideo: false,
                videoConfig: null,
            }
        },
        async mounted() {
            await this.searchFormWidth(); // 组件初始化的时候不会触发onresize事件，这里强制执行一次
            // console.log('Current Swiper instance object', this.mySwiper)
            if(!this.isWap) {this.mySwiper.slideTo(3, 1500, true);}
        },
        methods: {
            prev(){
                this.mySwiper.slidePrev();
            },
            next(){
                this.mySwiper.slideNext();
            },
            searchFormWidth() {
              let w = window.innerWidth;
              if (w <= 768) {
                this.isWap = true;
              } else {
                this.isWap = false;
              }
            },
            closeVideo(isclose) {
                this.openVideo = isclose;
                document
                    .getElementsByTagName("body")[0]
                    .classList.remove("el-popup-parent--hidden");
            },
            openVideoEvent(cfg) {
                this.videoConfig = cfg;
                this.openVideo = true;
                document
                    .getElementsByTagName("body")[0]
                    .classList.add("el-popup-parent--hidden");
            }
        }
    }
</script>

<style lang="scss" scoped>
    .swiper-container {
        width: 1440px;
        height: 470px;
        .swiper-slide {
            width: 456px;
            transition: all .6s;

        }
        .f-box {
            width: 456px;
            height: 470px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 24px;
            }
        }
        // 最外边两个缩小
        .swiper-slide{
            transition: all .5s;
            transform: scale(0.51);
            z-index: 2;
        }
        .swiper-slide div {
            background: #fff;
        }
        .swiper-slide img {
            transition: all .5s;
            opacity: 0.4;
        }
            /* 中间放大 */
        .swiper-slide-active,
        .swiper-slide-duplicate-active {
            transition: all .3s;
            transform: scale(1); 
            z-index: 5;
        }

        /* 中间透明度正常 */
        // .swiper-slide-active,
        // .swiper-slide-duplicate-active div {
        //     opacity: 1;
        // }
        .swiper-slide-active img,
        .swiper-slide-duplicate-active img {
            transition: all .3s;
            opacity: 1;
        }

        .swiper-slide-next {
            transition: all .5s;
            z-index: 6;
        }
        

        /* 左右两张缩小 */
        .swiper-slide-prev,
        .swiper-slide-next {
            transition: all .4s;
            transform: scale(0.81);
            z-index: 4;
        }

        /* 左右两张透明度减少 */
        .swiper-slide-prev img,
        .swiper-slide-next img{
            transition: all .5s;
            opacity: 0.6;
        }
        .swiper-slide-prev div,
        .swiper-slide-next div{
            background: #fff;
        }

        .swiper-button-prev:after, .swiper-button-next:after {
            font-size: 14px;
            color: #242933;
        }

        .swiper-button-next,.swiper-button-prev {
            transition: all .5s;
            width: 48px;
            height: 48px;
            background-color: #FFFFFF;
            opacity: .6;
            border-radius: 50%;
            top: 50%;
            margin-top: 0;
            transform: translateY(-50%);
        }
        .swiper-button-next {
            right: 160px;
        }
        .swiper-button-prev {
            left: 160px;
        }
        
    }  
    .main {
        font-family: "font-HYQH-65S";
        color: #242933;
        width: 1440px;
        margin: 0 auto;
        margin-top: 120px;
        h2 {
            font-size: 54px;
            line-height: 1.5;
        }
        .title-box {
            font-size: 40px;
            line-height: 1.5;
            padding: 60px 0;
            border-bottom: 1px solid #E4E4E4;
            margin-bottom: 60px;
        }
        .warchFilm {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 127px;
            li {
                position: relative;
                height: 257px;
                width: 456px;
                border-radius: 24px;
                overflow: hidden;
                .mask {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    background-color: #000;
                    transition: opacity 0.3s ease;
                    z-index: 1;
                }
                &:hover {
                    .mask {
                        opacity: .3;
                    }
                    .bgImg {
                        transform: scale(1.1);
                    }
                }
                .content {
                    position: absolute;
                    left: 30px;
                    bottom: 30px;
                    color: #fff;
                    font-size: 16px;
                    line-height: 1.5;
                    z-index: 1;
                    .title {
                        font-size: 28px;
                        margin-bottom: 30px;
                    }
                    .text {
                        cursor: pointer;
                        span {
                            margin-right: 8px;
                        }
                        img {
                            width: 8px;
                            height: 12px;
                            vertical-align: middle;
                        }
                    }
                }
                .bgImg {
                    width: 100%;
                    height: 100%;
                    transition: transform 0.3s ease;
                    transform: scale(1);
                }
            }
        }
        .logo-box {
            width: 600px;
            height: 98px;
            margin: 0 auto;
            margin-bottom: 180px;
            margin-top: 135px;
            //   background-color: red;
            display: flex;
            justify-content: space-between;
            .content {
                display: flex;
                align-items: center;
                div {
                    margin-right: 30px;
                    font-family: 'font-HYQH-55S';
                    font-size: 12px;
                    color: #8A8F99;
                    white-space: nowrap;
                }
            }
            img { 
                width: 126px;
                height: 98px;
                // margin: auto 0;
            }
            .img-left {
                width: 126px;
                height: 100%;
            }
        }
    }
    @media screen and (min-width: 1921px) {
        .swiper-container {
            width: 1440Px;
            height: 470Px;
            .swiper-slide {
                width: 456Px;
            }
            .f-box {
                width: 456Px;
                height: 470Px;
                img {
                    border-radius: 24Px;
                }
            }

            .swiper-button-prev:after, .swiper-button-next:after {
                font-size: 14Px;
            }

            .swiper-button-next,.swiper-button-prev {
                width: 48Px;
                height: 48Px;
            }
            .swiper-button-next {
                right: 160Px;
            }
            .swiper-button-prev {
                left: 160Px;
            }
            
        }  
        .main {
            width: 1440Px;
            margin-top: 120Px;
            h2 {
                font-size: 54Px;
            }
            .title-box {
                font-size: 40Px;
                padding: 60Px 0;
                border-bottom: 1Px solid #E4E4E4;
                margin-bottom: 60Px;
            }
            ul {
                margin-bottom: 127Px;
                li {
                    height: 257Px;
                    width: 456Px;
                    border-radius: 24Px;
                    .content {
                        left: 30Px;
                        bottom: 30Px;
                        font-size: 16Px;
                        .title {
                            font-size: 28Px;
                            margin-bottom: 30Px;
                        }
                        .text {
                            span {
                                margin-right: 8Px;
                            }
                            img {
                                width: 8Px;
                                height: 12Px;
                            }
                        }
                    }
                }
            }
            .logo-box {
                width: 600Px;
                height: 98Px;
                margin-bottom: 180Px;
                margin-top: 135Px;
                .content {
                    div {
                        margin-right: 30Px;
                        font-size: 12Px;
                    }
                }
                img { 
                    width: 126Px;
                    height: 98Px;
                    margin: auto 0;
                }
                .img-left {
                    width: 126Px;
                }
            }
            .warchFilm {
                margin-bottom: 127Px;
                li {
                    height: 257Px;
                    width: 456Px;
                    border-radius: 24Px;
                    .content {
                        left: 30Px;
                        bottom: 30Px;
                        font-size: 16Px;
                        .title {
                            font-size: 28Px;
                            margin-bottom: 30Px;
                        }
                        .text {
                            span {
                                margin-right: 8Px;
                            }
                            img {
                                width: 8Px;
                                height: 12Px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .main {
            width: calc( 100% - 38PX);
            // padding: 0 19PX;
            margin-top: 80*5.12px;
            box-sizing: border-box;
            h2 {
                font-size: 31*5.12px;
            }
            .title-box {
                font-size: 24*5.12px;
                padding: 30*5.12px 0 20*5.12px 0;
                border-bottom: 1Px solid #E4E4E4;
                margin-bottom: 24*5.12px;
            }
            .warchFilm {
                margin-bottom: 36*5.12px;
                flex-wrap: wrap;
                li {
                    height: 200*5.12px;
                    width: 100%;
                    border-radius: 12*5.12px;
                    margin-bottom: 24 * 5.12px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .mask {
                        display: none;
                    }
                    &:hover {
                        .bgImg {
                            transform: scale(1);
                        }
                    }
                    .content {
                        left: 30*5.12px;
                        bottom: 32*5.12px;
                        font-size: 12*5.12px;
                        .title {
                            font-size: 20*5.12px;
                            line-height: 1;
                            margin-bottom: 10*5.12px;
                        }
                        .text {
                            span {
                                margin-right: 5*5.12px;
                            }
                            img {
                                width: 6*5.12px;
                                height: 9*5.12px;
                            }
                        }
                    }
                }
            }
            .flimList {
                // width: 100%;
                width: calc( 100% + 38PX);
                overflow: hidden;
                margin-left: -19PX;
                padding-left: 19PX;
                .scroll {
                    min-width: 101%;
                    overflow-x: scroll;
                    display: flex;
                    justify-content: space-between;
                    overflow-y: hidden;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar {display:none}
                    .item {
                        margin-right: 20 * 5.12px;
                        &:last-child {
                            margin-right: 40 * 5.12px;
                        }
                        img {
                            width: 260 * 5.12px;
                            height: 220 * 5.12px;
                            object-fit: cover;
                            border-radius: 12 * 5.12px;
                        }
                    }
                }
                p {
                    font-size: 14 * 5.12px;
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 30 * 5.12px;
                    margin-left: -19PX;
                    img {
                        vertical-align: middle;
                        margin-left: 8 * 5.12px;
                    }
                }
            }
            .logo-box {
                width: 100%;
                height: auto;
                margin-bottom: 120 * 5.12px;
                margin-top: 80 * 5.12px;
                flex-direction: column;
                align-items: center;
                .content {
                    flex-wrap: wrap;
                    width: 90 * 5.12px;
                    justify-content: center;
                    margin-bottom: 50 * 5.12px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    div {
                        margin-right: 0;
                        font-size: 12 * 5.12px;
                    }
                }
                img { 
                    width: 48 * 5.12px;
                    height: 48 * 5.12px;
                    margin-top: 20 * 5.12px;
                }
                .img-left {
                    width: 89 * 5.12px;
                    height: 70 * 5.12px;
                    margin-top: 10 * 5.12px;
                }
            }
        }
    }
</style>